var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37232 5.98101C6.24625 5.98101 6.12005 5.93282 6.0238 5.83657L1.09418 0.906947C0.901551 0.714322 0.901551 0.4024 1.09418 0.209898C1.2868 0.0173967 1.59872 0.0172734 1.79122 0.209898L6.37232 4.791L10.9534 0.209898C11.146 0.0172734 11.458 0.0172734 11.6505 0.209898C11.843 0.402524 11.8431 0.714445 11.6505 0.906947L6.72085 5.83657C6.6246 5.93282 6.4984 5.98101 6.37232 5.98101Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/drop-down-arrow.877027e7e9a7c28f66728fb15b7ebb47.svg";
export { ForwardRef as ReactComponent };